import React from 'react';
import TR from '../../Trans';
import Button from '@mui/material/Button';
import BDialog from './BDialog';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

function AndroidSubDialog(props) {

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      props.onClose();
    }
  };

  return (
    <BDialog disableRestoreFocus open={props.open} onKeyDown={handleKeyDown} onClose={props.onClose} sx={{ zIndex: "999999999999 !important" }}>
      <DialogContent>
        {TR.cm_go_to_shop_to_subscribe_and_return}
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={6} justifyContent="center">
          <Button color="success" onClick={props.onOk}>Ok</Button>
        </Stack>
      </DialogActions>
    </BDialog>
  );
}

export default AndroidSubDialog;